import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Button, Flex } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { GrFormView } from 'react-icons/gr';
import {
  ModalTodoList,
  ModalTodoListShow,
} from '../../components/upeosoft/ModalApp/ModalApp';
import { useSelector } from 'react-redux';
import { getToDo } from '../../network/todoList';
import StatusTag from '../../hooks/StatusHook';

const TodoList = ({ t }) => {
  const { data: user } = useSelector((state) => state.user);
  const client = useQueryClient();
  // const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState();
  //   const handleRemove = useMutation({
  //     mutationFn: (id) => deleteSupplier(id),
  //     onSuccess: (data) => {
  //       console.log(data, 'data');
  //       if (data?.message?.status === 500) {
  //         message.error(data?.message?.message);
  //         return false;
  //       }
  //       message.success(data?.message ? data?.message : 'Deleted successfully');
  //       client.invalidateQueries({ queryKey: [queryKeys.getSuppliers] });
  //     },
  //     onError: () => {
  //       message.error('Something went wrong');
  //     },
  //   });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getToDo, user?.email],
    queryFn: () => getToDo(user?.email),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.priority,
      dataIndex: 'priority',
      key: 'priority',
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              setEditId(record?.name);
              setOpen(true);
              setEdit(true);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.date,
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: t.description,
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: t.status,
      dataIndex: 'status',
      key: 'status',
      render: (text) => {
        return <StatusTag status={text} />;
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,

      render: (text, record) => {
        return (
          <Flex>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
              icon={<GrFormView />}
            />
            {/* <Popconfirm
              title={t.DeletetheSupplier + ` (${record?.name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm> */}
          </Flex>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      <Heading title={t.TodoList} subTitle={t.TodoList} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        Placeholder={t.searchByName}
        buttonModal={false}
      />
      <ModalTodoListShow
        open={open}
        setOpen={setOpen}
        edit={edit}
        editId={editId}
        t={t}
        setEdit={setEdit}
      />
    </div>
  );
};

export default TodoList;
